import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "text-sm absolute top-0 right-0" }
const _hoisted_3 = {
  key: 0,
  class: "text-red-600 w-full justify-center text-sm font-bold pb-4 items-end flex"
}
const _hoisted_4 = { class: "pt-4" }

import { 
		Auth
	} from 'aws-amplify'

	// router
	import {
		useRouter,
		useRoute
	} from 'vue-router'

	// store
	import { 
		store as _systemStore
	} from '@/store/system'
	
	import { 
		store as _userStore
	} from '@/store/user'

	// types
	import { 
		CognitoUser
	} from '@aws-amplify/auth'
	
	// vue
	import {
		ref
	} from 'vue'

	
	const __default__ = { name: 'SignInForm' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: [
		'passwordExpired'
	],
  setup(__props, { emit: __emit }) {

	// api
	const emit = __emit

	const route = useRoute()
	const router = useRouter()
	
	const userStore = _userStore()
	const systemStore = _systemStore()

	// #region Sign in form
	const email = ref("")
	const password = ref("")
	const loading = ref(false)
	const signInError = ref(false)
	const user = ref({} as CognitoUser)
	const message = ref<string>('')

	async function signIn() {
		try {
			loading.value = true
			message.value = ""

			// check for empty field values
			if (email.value == "") {
				document.getElementById('email')?.focus()
				signInError.value = true
				throw 'Empty email'
			}
			else if (password.value == "") {
				document.getElementById('password')?.focus()
				signInError.value = true
				throw 'Empty password'
			}
		
			// attempt sign in
			user.value = await Auth.signIn(email.value, password.value)
			userStore.user.cognitoUser = user.value

			if(user.value?.challengeName === "NEW_PASSWORD_REQUIRED") { // go to update one time password form
				loading.value = false
				emit('passwordExpired')
			}
			else {			  
				loading.value = false
				router.push(route?.query?.redirect ? String(route?.query?.redirect) : { name: systemStore.system.primaryRoute})
			}
		}
		catch(error:any) {
			if(String(error).includes('PasswordResetRequiredException')) { // password was reset through Cognito console
				router.push({name: 'ResetPasswordRequested', state: {email: email.value}})
			}
			else if(String(error).includes('UserNotConfirmedException')) {
				// resendConfirmationCode()
				// router.push({name: 'AccountConfirmation', params: {email: email.value}})
			}
			else if(String(error).includes('Incorrect username or password')) {
				message.value = "Invalid email or password."
			}
			else if(String(error).includes('UserNotFoundException')) {
				message.value = 'Invalid email or password.'
			}
			else if(String(error).includes('Password attempts exceeded')) {
				message.value = "Password attempts exceeded. Please try again later or reset your password using the 'Forgot your password?' button."
			}
			else if(String(error).includes('Empty password') || String(error).includes('Empty email')) {
				return
			}
			else {
				message.value = "There was an issue with logging into your account. Please try again or contact us for assistance."
			}
		}
		finally {
			loading.value = false
		}
	}
  // #endregion

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (signIn()), ["prevent"])),
      class: "space-y-6"
    }, [
      _createElementVNode("div", null, [
        _createVNode(_component_tw_input, {
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          id: "email",
          name: "email",
          required: true,
          type: "email",
          autocomplete: "email",
          label: "Email address",
          validation: "Please enter your email address."
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_tw_input, {
          modelValue: password.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          id: "password",
          name: "password",
          required: true,
          type: "password",
          autocomplete: "current-password",
          label: "Password",
          validation: "Please enter your password."
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: {name: 'ForgotPassword'},
            class: "link"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Forgot your password? ")
            ])),
            _: 1,
            __: [3]
          })
        ])
      ]),
      _createElementVNode("div", null, [
        (message.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(message.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_tw_button, {
            type: "submit",
            class: "btn-db-yellow w-full",
            disabled: loading.value,
            loading: loading.value
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" Log In ")
            ])),
            _: 1,
            __: [4]
          }, 8, ["disabled", "loading"])
        ])
      ])
    ], 32)
  ]))
}
}

})